

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _choice = require('xo-models/src/choice');

var _index = require('xo-models/src/fi/index');

var _index2 = require('xo-models/src/checkout/index');

var _factory = require('xo-ui-components/src/expired-fi-panel/factory');

var _fiMeta = require('xo-models/src/fiMeta');

var _fiMeta2 = _interopRequireDefault(_fiMeta);

var _sharedUtil = require('../services/shared-util');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/popup/directive');

require('xo-ui-components/src/experience/directive');

require('xo-ui-components/src/fi-panel/directive');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/cardicon/directive');

require('xo-ui-components/src/expired-fi-panel/directive');

var _cardartInstrument = require('../services/cardart-instrument');

var _experiments = require('xo-models/src/experiments');

var Experiments = _interopRequireWildcard(_experiments);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$SidebarManageWalletDirective', {
    tag: 'xo-manage-wallet',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                cart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](_angular.noop),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop)
            };
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    all: _factory.$ExpiredFiPanelFactory.getAllInstruments(models),
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        },
        padToggleFeature: function padToggleFeature(resolvers) {
            return resolvers.models.then(function (models) {
                var enabled = void 0;

                if (models.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    enabled = Experiments.padToggleFeatureSupported();
                } else {
                    // if pad not availabe
                    enabled = false;
                }
                return { enabled: enabled };
            });
        },
        ppBalanceRebrandedExperiment: function ppBalanceRebrandedExperiment() {
            return {
                enabled: _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale)
            };
        }
    },
    actions: {
        toggleInfoMsg: function toggleInfoMsg($index) {
            this.disallowedIndex = this.disallowedIndex === $index ? -1 : $index;
        },
        confirm: function confirm($index) {
            this.selectedIndex = $index;
            this.deleteCard = true;
        },
        deleteFS: function deleteFS(fundingsource) {
            var _this = this;

            /**
             * Call walletfiserv to delete selected card and call Symphony's notifyChangeFundingInstruments api
             * to get back updated funding options.
             */
            this.deleteCardModel = new _index.$DeleteCardModel({
                id: fundingsource.id
            });
            this.deleteCardModel.save({
                data: this.deleteCardModel,

                contingencies: {
                    DELETE_CARD_CONTINGENCY: function DELETE_CARD_CONTINGENCY() {
                        _this.handleSingleContingency('creditcard.errorDeleteCard');
                        return;
                    }
                },

                error: function error() {
                    _this.handleSingleContingency('creditcard.errorDeleteCard');
                    return;
                },

                /**
                 * Call notifyChangeFundingInstruments to get updated funding options from checkout session
                 * During this call if any error or contingencies return back, just remove the deleted FI from checkout
                 * session as its already deleted successfully
                 */
                success: function success() {
                    _this.models.checkoutSession.fundingOptions.action('notifyChange', {
                        resultModel: _this.models.checkoutSession,

                        data: {
                            planId: fundingsource.id,
                            operation: 'REMOVED'
                        },
                        success: function success() {
                            _logger.$logger.info('manage_wallet: deleted FI - 1', fundingsource.id);
                            _this.selectedIndex = -1;
                            _this.disallowedIndex = -1;
                            return _factory.$ExpiredFiPanelFactory.getAllInstruments(_this.models).then(function (result) {

                                // Showing all plans but not pad plans for PAD2.0
                                if (_this.padToggleFeature.enabled) {
                                    _this.instruments = result.filter(function (plan) {
                                        return plan.subtype !== 'PAD';
                                    });
                                } else {
                                    _this.instruments = result;
                                }
                            });
                        },
                        contingencies: {
                            NOTIFY_FUNDING_CHANGE_CONTINGENCY: function NOTIFY_FUNDING_CHANGE_CONTINGENCY() {
                                return _this.removeFIFromCheckoutSession(fundingsource);
                            }
                        },
                        error: function error() {
                            return _this.removeFIFromCheckoutSession(fundingsource);
                        }
                    });
                }
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.handleSingleContingency = function (errorKey) {
                var messages = [];

                messages.push(_squid.$locale.content.get(errorKey));
                _this2.message = {
                    msgs: messages,
                    type: 'error'
                };
                _this2.isSystemError = true;
                _this2.selectedIndex = -1;
                _this2.disallowedIndex = -1;
            };

            this.removeFIFromCheckoutSession = function (fundingsource) {
                return _factory.$ExpiredFiPanelFactory.getAllInstruments(_this2.models).then(function (result) {
                    _this2.instruments = _squid.$util.filter(result, function (instrument) {
                        return instrument.id !== fundingsource.id;
                    });
                });
            };

            this.editDisallowedMsg = function (fi) {
                return _this2.models.fiMeta.getEditDisallowedContentKey(fi);
            };
        },
        populate: function populate() {
            var _models = this.models,
                checkoutSession = _models.checkoutSession,
                variant = _models.variant;
            var _fiSource = this.fiSource,
                all = _fiSource.all,
                isCardArtExp = _fiSource.isCardArtExp,
                isBillingNoPurchase = _fiSource.isBillingNoPurchase;

            var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

            this.isCreditDisallowedForMerchant = checkoutSession && checkoutSession.isCreditDisallowedForMerchant;
            this.creditDisallowedMessage = {
                type: 'info',
                msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
            };

            this.showMultipleFI = multipleFiVariants.indexOf(variant) > -1;
            this.message = checkoutSession && checkoutSession.message;
            this.isSystemError = this.message && this.message.type === 'error';

            if (this.models.checkoutSession.message && !this.models.checkoutSession.message.keepMsg) {
                this.models.checkoutSession.message = null;
            }
            // Showing all plans but not pad plans for PAD2.0
            if (this.padToggleFeature.enabled) {
                this.instruments = all.filter(function (plan) {
                    return plan.subtype !== 'PAD';
                });
            } else {
                this.instruments = all;
            }

            if (_squid.$locale.country === 'DE') {
                // Filter out the BILL_ME_LATER FI in DE since it is close-ended
                // and cannot be managed through hermes
                this.instruments = all.filter(function (plan) {
                    return !(plan.type === 'CREDIT' && plan.name === 'BILL_ME_LATER');
                });
            }

            /**
             * Log our cardart instrumentation.
             * See $CardArtInstrument.createPayload() for detailed implementation
             */
            if (isCardArtExp) {
                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'MANAGE_WALLET',
                    to: 'prepare_manage_wallet'
                }, _cardartInstrument.$CardArtInstrument.createPayload({
                    checkoutSession: checkoutSession,
                    isBillingNoPurchase: isBillingNoPurchase
                })));
            }
        }
    }
});


_angular.noop;

_squid.$Component;

_squid.$locale;

_squid.$config;

_squid.$util;

_logger.$logger;

_choice.$ChoiceEligibility;

_index.$DeleteCardModel;

_index2.$CheckoutSessionModel;

_index2.$CheckoutCartModel;

_factory.$ExpiredFiPanelFactory;

_sharedUtil.$SharedUtil;

_cardartInstrument.$CardArtInstrument;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-manage-wallet/directive.js
// module id = ./pages/xo-sidebar-manage-wallet/directive.js
// module chunks = 0